import { render } from "./SecondaryCTA.vue?vue&type=template&id=3b2b2388&scoped=true"
import script from "./SecondaryCTA.vue?vue&type=script&lang=js"
export * from "./SecondaryCTA.vue?vue&type=script&lang=js"

import "./SecondaryCTA.vue?vue&type=style&index=0&id=3b2b2388&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2b2388"]])

export default __exports__